export default "__VITE_ASSET__0d5f9a27__"